import { render, staticRenderFns } from "./HomeWrapper.vue?vue&type=template&id=01353afe&"
import script from "./HomeWrapper.vue?vue&type=script&lang=js&"
export * from "./HomeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./HomeWrapper.vue?vue&type=style&index=0&id=01353afe&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports